import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import axios from "axios";
import { checkAuth } from '../auth/auth.js';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "widgets" */ '../views/LoginView.vue')
  },
  {
    path: '/',
    name: 'Dashboard',
    component: HomeView
  },
  {
    path: '/campaigns',
    name: 'Campaigns',
    component: () => import(/* webpackChunkName: "campaigns" */ '../views/CampaignsView.vue')
  },
  {
    path: '/campaigns/my-campaigns',
    name: 'My Campaigns',
    meta: {
      parent: 'Campaigns',
      url: '/campaigns'
    },
    component: () => import(/* webpackChunkName: "campaigns" */ '../views/YourCampaignsView.vue')
  },
  {
    path: '/campaigns/:id',
    name: 'Campaign',
    meta: {
      parent: 'Campaigns',
      url: '/campaigns'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Campaign-Single.vue')
  },
  {
    path: '/:slug',
    name: 'Page',
    component: () => import(/* webpackChunkName: "about" */ '../views/Page.vue')
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import(/* webpackChunkName: "reports" */ '../views/ReportsView.vue')
  },
  {
    path: '/widgets',
    name: 'Widgets',
    component: () => import(/* webpackChunkName: "widgets" */ '../views/WidgetView.vue')
  },
  {
    path: '/payments',
    name: 'Payments',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "widgets" */ '../views/PaymentsView.vue')
  },
  {
    path: '/edit-profile',
    name: 'Edit Profile',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "widgets" */ '../views/EditProfile.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "widgets" */ '../views/AdminView.vue')
  },
  {
    path: '/admin/member/:id',
    name: 'Admin Member',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "widgets" */ '../views/Admin/AdminMemberView.vue')
  },
  {
    path: '/admin/campaign/:id',
    name: 'Admin Campaign',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "widgets" */ '../views/Admin/AdminCampaignView.vue')
  },
]

function getSessionToken() {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.trim().split('=');
    if (cookieName === 'user_session') {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}


const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = getSessionToken();
  if (!token && to.path !== '/login') {
    next('/login');
  } else {
    if (to.meta.requiresAuth) {
      let isAuthenticated = checkAuth();
      if(isAuthenticated) {
        next();
      }else{
        next('/login');
      }
    } else {
      next();
    }
  }
});


export default router
